import { Browser, MobileOS } from '../../enums/DeviceInfoType';

type deviceInfo = {
  deviceOS: MobileOS;
  browser: Browser;
};

export const getDeviceInfo = (): deviceInfo => {
  return { deviceOS: checkDeviceOS(), browser: checkBrowserName() };
};

const checkDeviceOS = (): MobileOS => {
  if (
    navigator.userAgent.match(/iPhone/) ||
    navigator.userAgent.match(/iPad/) ||
    navigator.userAgent.match(/Macintosh/) ||
    navigator.userAgent.match(/MacIntel/)
  ) {
    return MobileOS.IOS;
  } else if (navigator.userAgent.match(/Android/)) {
    return MobileOS.ANDROID;
  } else if ((window.navigator as any)?.userAgentData?.platform !== undefined) {
    if ((window.navigator as any).userAgentData.platform === MobileOS.WINDOWS) {
      return MobileOS.WINDOWS;
    } else if ((window.navigator as any).userAgentData.platform === MobileOS.LINUX) {
      return MobileOS.LINUX;
    } else {
      return MobileOS.UNKNOWN;
    }
  } else {
    return MobileOS.UNKNOWN;
  }
};

const checkBrowserName = (): Browser => {
  const isChrome = navigator.userAgent.includes('Chrome');
  const isFirefox = navigator.userAgent.includes('Firefox');
  const isSafari = navigator.userAgent.includes('Safari') && !isChrome; // Chrome also reports as Safari
  const isEdge = navigator.userAgent.includes('Edg'); // New Edge based on Chromium
  const isIE = navigator.userAgent.includes('Trident') || navigator.userAgent.includes('MSIE'); // Older versions of IE

  let browserName = Browser.UNKNOWN;

  if (isChrome) {
    browserName = Browser.CHROME;
  } else if (isFirefox) {
    browserName = Browser.FIREFOX;
  } else if (isSafari) {
    browserName = Browser.SAFARI;
  } else if (isEdge) {
    browserName = Browser.EDGE;
  } else if (isIE) {
    browserName = Browser.IE;
  } else {
    browserName = Browser.UNKNOWN;
  }

  return browserName;
};
